import { getReduxStore, globalReducers, initializeReduxHost, isReduxHostInitialized } from './redux-host.js';
import { setHostInfo } from './triggers.js';
/**
 *
 * @deprecated please use 'initializeHost()' instead.
 */
export function initializeCrystalHost(initialState) {
    if (!isReduxHostInitialized()) {
        initializeReduxHost(globalReducers, initialState, initialState?.host?.context.env);
    }
}
export function isHostInitialized() {
    if (!isReduxHostInitialized()) {
        return false;
    }
    const { host } = getReduxStore().getState();
    return !!Object.keys(host.context).length;
}
export function initializeHost(hostInfo) {
    if (!isReduxHostInitialized()) {
        const initialState = {
            host: hostInfo,
        };
        initializeReduxHost(globalReducers, initialState, hostInfo.context.env);
    }
    else {
        setHostInfo(hostInfo);
    }
}
//# sourceMappingURL=initialization.js.map